/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.
 */

(function() {
  if (window.__bareCustomJsLoaded) return;
  window.__bareCustomJsLoaded = true;

  function updateColorName(input) {
    const colorName = input?.getAttribute('data-color-name');
    const swatchContainer = input?.closest('[data-swatches-container]');
    const colorNameDisplay = swatchContainer?.querySelector('[data-selected-color-name]');

    if (colorNameDisplay && colorName) {
      colorNameDisplay.textContent = colorName;
    }
  }

  function parseVariantsOnSale(data) {
    return String(data || '')
      .split(',')
      .reduce((variants, entry) => {
        const parts = entry.split(':');
        if (parts.length === 2 && parts[0]) {
          variants[parts[0].trim()] = parts[1].trim() === 'true';
        }

        return variants;
      }, {});
  }

  function toggleSaleBadges(scope, isVariantOnSale) {
    const redSaleBadge = scope?.querySelector('.product-badge__item--sale-red');
    const customBadge = scope?.querySelector('.product-badge__item--custom');

    if (redSaleBadge) {
      redSaleBadge.style.display = isVariantOnSale ? '' : 'none';
      redSaleBadge.classList.toggle('hidden', !isVariantOnSale);
    }

    if (customBadge) {
      customBadge.style.display = isVariantOnSale ? 'none' : '';
      customBadge.classList.toggle('hidden', isVariantOnSale);
    }
  }

  function updateSaleBadgeFromVariant(productForm) {
    const variantInput = productForm?.querySelector('input[name="id"]');
    if (!variantInput) return;

    const variantsOnSale = parseVariantsOnSale(productForm.dataset.variantsOnSale);
    const isVariantOnSale = variantsOnSale[variantInput.value] === true;
    const scope = productForm.closest('[data-product-block], [data-product], .product-single') || productForm;

    toggleSaleBadges(scope, isVariantOnSale);
  }

  function extractYouTubeId(url) {
    const value = String(url || '');
    const iframeSrc = value.match(/src=["'][^"']*\/embed\/([^"'?&]*)/);
    if (iframeSrc && iframeSrc[1]) return iframeSrc[1];

    const match = value.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/);
    return match && match[2].length === 11 ? match[2] : null;
  }

  function getVideoModal(uniqueId) {
    let modal = document.getElementById('video-modal-' + uniqueId);
    if (modal) {
      const existingContent = modal.querySelector('#video-content-' + uniqueId);
      if (existingContent && !existingContent.hasAttribute('data-video-modal-content')) {
        existingContent.setAttribute('data-video-modal-content', '');
      }

      return modal;
    }

    modal = document.createElement('div');
    modal.id = 'video-modal-' + uniqueId;
    modal.className = 'video-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.hidden = true;
    modal.innerHTML = `
      <div class="video-modal__content" role="document">
        <button class="video-modal__close" type="button" data-video-modal-close="${uniqueId}" aria-label="Close video">×</button>
        <div class="video-modal__container" data-video-modal-content></div>
      </div>
    `;

    document.body.appendChild(modal);
    return modal;
  }

  function loadVideoContent(modal, videoUrl) {
    const videoContainer = modal.querySelector('[data-video-modal-content]');
    if (!videoContainer) return;

    const videoId = extractYouTubeId(videoUrl);

    if (videoId) {
      videoContainer.innerHTML = `
        <iframe
          src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&enablejsapi=1"
          width="100%"
          height="100%"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      `;
      return;
    }

    videoContainer.innerHTML = `
      <div class="video-modal__fallback">
        <h3>Watch Video</h3>
        <p>Click the link below to watch the video:</p>
        <a href="${videoUrl || '#'}" target="_blank" rel="noopener noreferrer">Open Video</a>
      </div>
    `;
  }

  function openVideoModal(trigger) {
    const videoUrl = trigger.getAttribute('data-video-url');
    const uniqueId = trigger.getAttribute('data-video-modal-trigger') || 'default';
    const modal = getVideoModal(uniqueId);

    modal.dataset.previousBodyOverflow = document.body.style.overflow || '';
    modal.dataset.previousDisplay = modal.style.display || '';
    loadVideoContent(modal, videoUrl);
    modal.hidden = false;
    modal.style.display = 'flex';
    modal.style.visibility = 'visible';
    modal.style.opacity = '1';
    modal.classList.add('is-visible');
    modal.classList.add('modal-visible');
    document.body.style.overflow = 'hidden';

    modal.querySelector('[data-video-modal-close]')?.focus();
  }

  function closeVideoModal(modal) {
    if (!modal) return;

    const videoContainer = modal.querySelector('[data-video-modal-content]');
    if (videoContainer) {
      videoContainer.innerHTML = '';
    }

    modal.classList.remove('is-visible');
    modal.classList.remove('modal-visible');
    modal.hidden = true;
    modal.style.display = modal.dataset.previousDisplay || 'none';
    document.body.style.overflow = modal.dataset.previousBodyOverflow || '';
    delete modal.dataset.previousBodyOverflow;
    delete modal.dataset.previousDisplay;
  }

  function injectVideoModalStyles() {
    if (document.getElementById('bare-video-modal-styles')) return;

    const style = document.createElement('style');
    style.id = 'bare-video-modal-styles';
    style.textContent = `
      .video-modal[hidden] { display: none; }
      .video-modal {
        align-items: center;
        background: rgba(0, 0, 0, 0.9);
        bottom: 0;
        display: flex;
        justify-content: center;
        left: 0;
        padding: 20px;
        position: fixed;
        right: 0;
        top: 0;
        z-index: 10000;
      }
      .video-modal__content {
        background: #000;
        border-radius: 8px;
        max-width: 900px;
        position: relative;
        width: min(100%, 900px);
      }
      .video-modal__close {
        align-items: center;
        background: rgba(0, 0, 0, 0.7);
        border: 0;
        border-radius: 50%;
        color: #fff;
        cursor: pointer;
        display: flex;
        font-size: 24px;
        height: 40px;
        justify-content: center;
        line-height: 1;
        position: absolute;
        right: 10px;
        top: 10px;
        width: 40px;
        z-index: 1;
      }
      .video-modal__container {
        aspect-ratio: 16 / 9;
        min-height: 240px;
        width: 100%;
      }
      .video-modal__container iframe {
        display: block;
        height: 100%;
        width: 100%;
      }
      .video-modal__fallback {
        color: #fff;
        padding: 40px;
        text-align: center;
      }
      .video-modal__fallback a {
        color: #fff;
        text-decoration: underline;
      }
    `;
    document.head.appendChild(style);
  }

  document.addEventListener('change', function(event) {
    const colorInput = event.target.closest('.swatch__input[data-color-name], .radio__input[data-color-name]');
    if (colorInput?.checked) {
      updateColorName(colorInput);
    }

    const selector = event.target.closest('[data-single-option-selector]');
    const productForm = selector?.closest('form[data-product-form]');
    if (productForm) {
      window.setTimeout(() => updateSaleBadgeFromVariant(productForm), 100);
    }
  });

  document.addEventListener('click', function(event) {
    const swatchButton = event.target.closest('[data-swatch-button]');
    if (swatchButton) {
      const productBlock = swatchButton.closest('[data-product-block]');
      const swatchLabel = swatchButton.querySelector('[data-swatch-variant]');

      if (productBlock && swatchLabel) {
        const variantsOnSale = parseVariantsOnSale(productBlock.dataset.variantsOnSale);
        toggleSaleBadges(productBlock, variantsOnSale[swatchLabel.dataset.swatchVariant] === true);
      }
    }

    const videoTrigger = event.target.closest('[data-video-modal-trigger]');
    if (videoTrigger) {
      event.preventDefault();
      event.stopPropagation();
      openVideoModal(videoTrigger);
      return;
    }

    const videoClose = event.target.closest('[data-video-modal-close]');
    if (videoClose) {
      closeVideoModal(videoClose.closest('.video-modal'));
      return;
    }

    if (event.target.classList.contains('video-modal')) {
      closeVideoModal(event.target);
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;

    const openModal = document.querySelector('.video-modal.is-visible');
    if (openModal) {
      closeVideoModal(openModal);
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    injectVideoModalStyles();

    document
      .querySelectorAll('.swatch__input[data-color-name]:checked, .radio__input[data-color-name]:checked')
      .forEach(updateColorName);
  });
})();
